import React, { Component } from 'react';
import logo from './assets/logo.png';
import { List, Card, Divider, Button, Icon } from 'antd';
import cookies from 'browser-cookies';

import {
  TOKEN_KEY,
  USER_KEY,
  COOKIE_DOMAIN,
  AUTH_HOST,
  PUBLIC_URL
} from './constants';
import './assets/App.css';

class App extends Component {
  state = {
    storybooks: [],
    token: null,
    user: {}
  }

  componentDidMount() {
    const token = cookies.get(TOKEN_KEY);
    let user;
    try {
      user = JSON.parse(cookies.get(USER_KEY));
    } catch (e) {
      user = {};
    }
    this.setState({ token, user });

    fetch(`${PUBLIC_URL}/storybooks.json`)
      .then((r) => r.json())
      .then(storybooks => {
          this.setState({ storybooks });
      })
  }

  isLoggedIn = (token, user) => (
    token &&
    user.email &&
    user.email.match(/@ninjavan\.co$/)
  )

  logout = () => {
    const allCookies = cookies.all();
    for (let cookieName in allCookies) {
      cookies.erase(cookieName, {domain: COOKIE_DOMAIN });
    }

    this.setState({
      token: null,
      user: {}
    });
  }

  render() {
    const { storybooks, token, user } = this.state
    const isLoggedIn = this.isLoggedIn(token, user)
    const isLoading = storybooks.length === 0

    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">Ninja Storybooks</h1>
        </header>
        <main className="App-index">
          { isLoggedIn ?
              <Button className="App-button-auth"
                  onClick={() => {this.logout()}}>
                  <Icon type="logout" />
                  Logout
              </Button> :
              <Button className="App-button-auth"
                  href={`${AUTH_HOST}?state=${window.location.origin}`}>
                  <Icon type="login" />
                  Login
              </Button>
          }
          { isLoggedIn &&
            <List
              grid={{ gutter: 16, xs: 1, sm: 2, md: 3, lg: 4, xl: 4, xxl: 6 }}
              dataSource={isLoading ? [{},{},{},{},{},{}] : storybooks}
              renderItem={({ name, version, title, description, date, url }) => (
                <List.Item>
                  <Card
                    hoverable={true}
                    onClick={() => window.open(`${url}/index.html`)}
                    loading={isLoading}
                    className="App-card"
                    title={<code>{name}</code>}
                    extra={version}>
                    <Card.Meta
                      title={title}
                      description={
                        <div>
                          {description}
                          <Divider className="App-divider" />
                          Last update: {new Date(date).toLocaleDateString()}
                        </div>
                      }
                    />
                  </Card>
                </List.Item>
              )}
            />
          }
        </main>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js